import { Injectable } from '@angular/core';
import { ICoordinatesViewModel } from 'app/system/mobile-models/profile-models';
import moment from 'moment-timezone';


@Injectable({
    providedIn: 'root'
})
export class TimeZoneConverterService {

    constructor() { }

    public toUTC(unixTime: number): Date {
        return moment.unix(unixTime).utc().toDate();
    }

    public toLocal(unixTime: number, timeZone: string): Date {

        if (!timeZone) {
            timeZone = "UTC";
        } 
        return moment.unix(unixTime).tz(timeZone).toDate();
    }

    public parsePoints(points: string): ICoordinatesViewModel[] {
        const numbers = points.trim().split(/\s+/).map(Number);
        const result: ICoordinatesViewModel[] = [];

        for (let i = 0; i < numbers.length; i += 2) {
            result.push({
                latitude: numbers[i],
                longitude: numbers[i + 1],
            });
        }
        return result;
    }
}

